import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl/dist';

const StyledContainer = styled.div`
    border-radius: 5px;
    border: ${({ theme }) => `1px solid ${theme.gray8}`};
`;

const MemberDetailsContainer = ({ id, heading, children }) => {
  return (
    <StyledContainer data-testid={`${id}-container`} className="member-details-container desktop:grid-col-9">
        <div data-testid={`${id}-title`} className="header margin20-b">
            <h3 className='heading'>
                <FormattedMessage id={heading} />
            </h3>
        </div>
        {children}
    </StyledContainer>
  )
};

export default MemberDetailsContainer;
